import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["onMouseover"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onMouseover"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onMouseover"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }

import { JournalListFilters } from "@/types/journal/JournalListFilters";
import moment from "moment";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { computed, onMounted, ref, inject } from "vue";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import {
  JournalListItem,
  DisplayedJournalListItem,
} from "@/types/journal/JournalListItem";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import { formatDate } from "bright-logic-core/src/format";
import { RouteNames } from "@/router/RouteNames";
import { useRouter } from "vue-router";
import EditUserModal from "../user-management/record/edit-user-modal.vue";
import InfoCard from "@/components/ui/containers/info-card.vue";
import InfoCardTitle from "@/components/ui/containers/info-card-title.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'journal-card',
  props: {
  /**
   * The width of the component, defined as a string.
   * @type {string}
   * @default '100%'
   */
  width: {
    type: String,
    default: "100%",
  },
},
  setup(__props) {

const props = __props;



const apiNextClient = inject("AcquaintApiNextClient") as AcquaintApiNextClient;
const loadingRecentPropertyChanges = ref(false);
const recentPropertyChanges = ref<JournalListItem[]>([]);
const displayedRecentPropertyChanges = ref<DisplayedJournalListItem[]>([]);
const router = useRouter();
const displayEditUserModal = ref(false);
const selectedUserId = ref(0);
const displayPropertyIcon = ref(false);
const displayContactIcon = ref(false);
const displayUserIcon = ref(false);
const hoverId = ref(0);
const apiFilters = computed(() => {
  const filters = new JournalListFilters();
  filters.startDate = moment()
    .subtract(1, "weeks")
    .startOf("week")
    .format("yyyy-MM-DD");
  filters.endDate = moment()
    .subtract(1, "weeks")
    .endOf("week")
    .format("yyyy-MM-DD");
  return filters;
});

onMounted(async () => {
  fetchRecentPropertyChanges();
});

// Fetch journal records
const fetchRecentPropertyChanges = async () => {
  loadingRecentPropertyChanges.value = true;
  try {
    recentPropertyChanges.value = await apiNextClient.httpPost(
      "journals",
      apiFilters.value,
    );
  } catch (error) {
    recentPropertyChanges.value = [];
    displayErrorMessage(getErrorMessage(error));
  } finally {
    displayedRecentPropertyChanges.value = recentPropertyChanges.value.map(
      (item, index) => {
        return {
          ...item,
          id: index,
        };
      },
    );
    loadingRecentPropertyChanges.value = false;
  }
};

// Grid formatting
const formatValue = (value: string) => {
  if (value.includes("¤")) {
    value = value.replace("¤", "£");
  }

  return value;
};

// Code for displaying records
const loadRecordPage = (id: number, loadContactRecord: boolean) => {
  router.push({
    name: loadContactRecord ? RouteNames.ContactPage : RouteNames.PropertyPage,
    params: loadContactRecord
      ? { contactid: id.toString() }
      : { propertyid: id.toString() },
  });
};

const loadUserModal = (id: number) => {
  selectedUserId.value = id;
  displayEditUserModal.value = true;
};

// Code thaat displays grid icons
const mouseOverProperty = (id: number) => {
  displayPropertyIcon.value = true;
  hoverId.value = id;
};

const mouseOverUser = (id: number) => {
  displayUserIcon.value = true;
  hoverId.value = id;
};

const mouseOverContact = (id: number) => {
  displayContactIcon.value = true;
  hoverId.value = id;
};

// Styling
const gridHeight = computed(() => {
  return `height: 450px;`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (displayedRecentPropertyChanges.value.length > 0)
      ? (_openBlock(), _createBlock(InfoCard, {
          key: 0,
          title: "Recent Property Changes",
          width: __props.width
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              style: _normalizeStyle(gridHeight.value)
            }, [
              _createVNode(GridBase, {
                wordWrapEnabled: true,
                loading: loadingRecentPropertyChanges.value,
                "data-source": displayedRecentPropertyChanges.value,
                "custom-column-slots": [
          'dateCell',
          'propertyCell',
          'contactCell',
          'userCell',
          'activityCell',
        ]
              }, {
                columns: _withCtx(() => [
                  _createVNode(_unref(DxColumn), {
                    "data-field": "date",
                    caption: "Date",
                    "hiding-priority": 5,
                    "cell-template": "dateCell",
                    width: "100px"
                  }),
                  _createVNode(_unref(DxColumn), {
                    visible: true,
                    "data-field": "property",
                    width: "350px",
                    caption: "Property",
                    "hiding-priority": 4,
                    "cell-template": "propertyCell"
                  }),
                  _createVNode(_unref(DxColumn), {
                    caption: "Activity",
                    "hiding-priority": 3,
                    "cell-template": "activityCell"
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "contact",
                    width: "250px",
                    caption: "Contact",
                    "hiding-priority": 2,
                    "cell-template": "contactCell"
                  }),
                  _createVNode(_unref(DxColumn), {
                    "data-field": "user",
                    caption: "User",
                    "hiding-priority": 1,
                    "cell-template": "userCell"
                  })
                ]),
                dateCellData: _withCtx(({ data }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(formatDate)(data.date)), 1)
                ]),
                activityCellData: _withCtx(({ data }) => [
                  _createElementVNode("div", null, _toDisplayString(data.type) + " from " + _toDisplayString(formatValue(data.oldValue)) + " to " + _toDisplayString(formatValue(data.newValue)), 1)
                ]),
                propertyCellData: _withCtx(({ data }) => [
                  _createElementVNode("div", {
                    class: "custom-journal-cell",
                    onMouseover: ($event: any) => (mouseOverProperty(data.id)),
                    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (displayPropertyIcon.value = false))
                  }, [
                    (
                displayPropertyIcon.value && data.propertyId > 0 && hoverId.value == data.id
              )
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "fa-solid fa-house",
                          onClick: ($event: any) => (loadRecordPage(data.propertyId, false))
                        }, null, 8, _hoisted_2))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(data.property), 1)
                  ], 40, _hoisted_1)
                ]),
                contactCellData: _withCtx(({ data }) => [
                  _createElementVNode("div", {
                    class: "custom-journal-cell",
                    onMouseover: ($event: any) => (mouseOverContact(data.id)),
                    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (displayContactIcon.value = false))
                  }, [
                    (
                displayContactIcon.value && data.contactId > 0 && hoverId.value == data.id
              )
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "fa-solid fa-user",
                          onClick: ($event: any) => (loadRecordPage(data.contactId, true))
                        }, null, 8, _hoisted_4))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(data.contact), 1)
                  ], 40, _hoisted_3)
                ]),
                userCellData: _withCtx(({ data }) => [
                  (data.userId != 999999999)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "custom-journal-cell",
                        onMouseover: ($event: any) => (mouseOverUser(data.id)),
                        onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (displayUserIcon.value = false))
                      }, [
                        (displayUserIcon.value && data.userId > 0 && hoverId.value == data.id)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: "fa-solid fa-user",
                              onClick: ($event: any) => (loadUserModal(data.userId))
                            }, null, 8, _hoisted_6))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(data.user), 1)
                      ], 40, _hoisted_5))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, "System User"))
                ]),
                _: 1
              }, 8, ["loading", "data-source"])
            ], 4)
          ]),
          _: 1
        }, 8, ["width"]))
      : (_openBlock(), _createBlock(InfoCardTitle, {
          key: 1,
          title: "Recent Property Changes - None Found",
          width: props.width
        }, null, 8, ["width"])),
    _createVNode(EditUserModal, {
      modelValue: displayEditUserModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((displayEditUserModal).value = $event)),
      "user-id": selectedUserId.value
    }, null, 8, ["modelValue", "user-id"])
  ], 64))
}
}

})